import { itemsOf, useApiQuery } from './hooks';
import type { Member } from './types';
import type { OrgApi } from './useOrgApi';

/** Miembros de la organización y un mapa uid → nombre visible; solo para roles que pueden listarlos. */
export function useMembers(client: OrgApi, enabled: boolean) {
  const query = useApiQuery(
    (signal) => (enabled ? client.get<{ items: Member[] }>('/v1/members', { signal }).then(itemsOf).catch(() => [] as Member[]) : Promise.resolve([] as Member[])),
    [client, enabled],
  );
  const members = query.data ?? [];
  const names: Record<string, string> = Object.fromEntries(members.map((m) => [m.uid, m.name ?? m.email ?? m.uid]));
  return { members, names, loading: query.loading };
}
